var _getCookie, _getCookie2;
import { getCookie } from '@beef/utils';
import { createSlice } from '@reduxjs/toolkit';
import { CAPTCHA_RECREATE_KEY, CAPTCHA_RETRY_KEY, COOKIE_TOKEN_INVALID_MESSAGE } from "../../../../shared/config";
import { LoadingStatus, generateCapthcaThunk, validateCaptchaThunk } from "../../../../shared/model";
import { changeCaptchaCounterStorage, getTokenData, saveActiveCaptchaMessageId, saveQueuedMessages, saveTargetCaptcha, setTokensToCookies } from "./utils";
var initialState = {
  retryCount: Number((_getCookie = getCookie(CAPTCHA_RETRY_KEY)) !== null && _getCookie !== void 0 ? _getCookie : 0),
  captchaAccessToken: getTokenData(),
  validateStatus: LoadingStatus.idle,
  createStatus: LoadingStatus.idle,
  queuedMessages: [],
  recreateCount: Number((_getCookie2 = getCookie(CAPTCHA_RECREATE_KEY)) !== null && _getCookie2 !== void 0 ? _getCookie2 : 0),
  recreateProcess: []
};
export var captchaSlice = createSlice({
  name: 'captcha',
  initialState: initialState,
  reducers: {
    setActiveCaptchaMessageId: function setActiveCaptchaMessageId(state, action) {
      state.activeCaptchaMessageId = action.payload;
      saveActiveCaptchaMessageId(action.payload);
    },
    setRetryCount: function setRetryCount(state, action) {
      changeCaptchaCounterStorage(state, 'retry', action.payload);
    },
    setCaptchaData: function setCaptchaData(state, action) {
      state.targetCaptchaData = action.payload;
    },
    addProcessId: function addProcessId(state, action) {
      state.recreateProcess.push(action.payload);
    },
    removeProcessId: function removeProcessId(state, action) {
      state.recreateProcess = state.recreateProcess.filter(function (el) {
        return el !== action.payload;
      });
    },
    setCaptchaAccessToken: function setCaptchaAccessToken(state, action) {
      state.captchaAccessToken = action.payload;
      if (action.payload) {
        setTokensToCookies(action.payload);
      }
    },
    addQueuedMessage: function addQueuedMessage(state, action) {
      state.queuedMessages.push(action.payload);
      saveQueuedMessages(state.queuedMessages);
    },
    clearQueuedMessages: function clearQueuedMessages(state) {
      state.queuedMessages = [];
      saveQueuedMessages(state.queuedMessages);
    },
    setQueuedMessages: function setQueuedMessages(state, action) {
      state.queuedMessages = action.payload;
      saveQueuedMessages(state.queuedMessages);
    },
    removeQueuedMessage: function removeQueuedMessage(state, action) {
      state.queuedMessages = state.queuedMessages.filter(function (_ref) {
        var messageId = _ref.messageId;
        return messageId !== action.payload;
      });
      saveQueuedMessages(state.queuedMessages);
    },
    setRecreateCount: function setRecreateCount(state, action) {
      changeCaptchaCounterStorage(state, 'recreate', action.payload);
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(validateCaptchaThunk.pending, function (state) {
      state.validateStatus = LoadingStatus.loading;
    }).addCase(validateCaptchaThunk.fulfilled, function (state, action) {
      var accessToken = action.payload.accessToken;
      state.captchaAccessToken = accessToken;
      setTokensToCookies(accessToken);
      changeCaptchaCounterStorage(state, 'retry', 0);
      changeCaptchaCounterStorage(state, 'recreate', 0);
      state.validateStatus = LoadingStatus.fulfilled;
    }).addCase(validateCaptchaThunk.rejected, function (state, action) {
      var error = action.payload;
      if ((error === null || error === void 0 ? void 0 : error.status) === 401 && (error === null || error === void 0 ? void 0 : error.message) !== COOKIE_TOKEN_INVALID_MESSAGE) {
        changeCaptchaCounterStorage(state, 'retry', state.retryCount + 1);
      }
      state.validateStatus = LoadingStatus.failed;
    }).addCase(generateCapthcaThunk.pending, function (state) {
      state.createStatus = LoadingStatus.loading;
    }).addCase(generateCapthcaThunk.fulfilled, function (state, action) {
      state.targetCaptchaData = action.payload;
      saveTargetCaptcha(action.payload);
      state.createStatus = LoadingStatus.fulfilled;
    }).addCase(generateCapthcaThunk.rejected, function (state) {
      state.createStatus = LoadingStatus.failed;
      state.targetCaptchaData = undefined;
    });
  }
});
var _captchaSlice$actions = captchaSlice.actions,
  setCaptchaData = _captchaSlice$actions.setCaptchaData,
  setRetryCount = _captchaSlice$actions.setRetryCount,
  addQueuedMessage = _captchaSlice$actions.addQueuedMessage,
  clearQueuedMessages = _captchaSlice$actions.clearQueuedMessages,
  setCaptchaAccessToken = _captchaSlice$actions.setCaptchaAccessToken,
  setQueuedMessages = _captchaSlice$actions.setQueuedMessages,
  addProcessId = _captchaSlice$actions.addProcessId,
  removeProcessId = _captchaSlice$actions.removeProcessId,
  setRecreateCount = _captchaSlice$actions.setRecreateCount,
  removeQueuedMessage = _captchaSlice$actions.removeQueuedMessage,
  setActiveCaptchaMessageId = _captchaSlice$actions.setActiveCaptchaMessageId;
export { setCaptchaData, setRetryCount, addQueuedMessage, clearQueuedMessages, setCaptchaAccessToken, setQueuedMessages, addProcessId, removeProcessId, setRecreateCount, removeQueuedMessage, setActiveCaptchaMessageId };